import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import dayjs from "dayjs";
import { useMessage } from "hooks/intl";

export const FEATURE_INTRO_DATES = {
  BADGES: new Date("2025-04-02"),
  LEADERBOARDS: new Date("2025-05-08"),
};

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    box: {
      backgroundColor: theme.orange300,
      borderRadius: "30px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      height: "18px",
      padding: theme.spacing(0, 4),
    },
    label: {
      fontSize: 12,
      color: theme.orange800,
      textTransform: "uppercase",
    },
  }),
);

interface Props {
  featureIntroductionDate: Date;
}

export const NewFeature = ({ featureIntroductionDate }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();
  const featureDate = dayjs(featureIntroductionDate);
  const expirationDate = featureDate.add(37, "day");
  const isOldFeature = dayjs().isAfter(expirationDate);

  return isOldFeature ? null : (
    <div className={classes.box}>
      <span className={classes.label}>{message({ id: "new" })}</span>
    </div>
  );
};
